import { render } from "./pb-blocktext.vue?vue&type=template&id=4390cbb5"
import script from "./pb-blocktext.vue?vue&type=script&lang=js"
export * from "./pb-blocktext.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__